import { unsetPendingSitPlayerAnimation } from './pokerActions';
export const CLEAR_ANIMATIONS_STATE = 'CLEAR_ANIMATIONS_STATE';
export const ADD_PLAYER_ANIMATION = 'ADD_PLAYER_ANIMATION';
export const REMOVE_PLAYER_ANIMATION = 'REMOVE_PLAYER_ANIMATION';
export const CLEAR_PLAYER_ANIMATIONS = 'CLEAR_PLAYER_ANIMATIONS';
export const ADD_TABLE_SHAKE_ANIMATION = 'ADD_TABLE_SHAKE_ANIMATION';
export const REMOVE_TABLE_SHAKE_ANIMATION = 'REMOVE_TABLE_SHAKE_ANIMATION';
export function clearAnimationsState() {
    return {
        type: CLEAR_ANIMATIONS_STATE
    };
}
export function addPlayerAnimation(seatIndex, playerAnimationBase) {
    return {
        type: ADD_PLAYER_ANIMATION,
        payload: { seatIndex, playerAnimationBase }
    };
}
export function removePlayerAnimation(seatIndex, id) {
    return {
        type: REMOVE_PLAYER_ANIMATION,
        payload: { seatIndex, id }
    };
}
function thunkAddSitPlayerAnimation(seatIndex) {
    return function (dispatch, getState) {
        const seatDimensions = getState().gameDimensions.seatDimensions;
        if (seatDimensions) {
            const absDropX = seatDimensions.w / 3;
            const dropX = seatIndex <= 5 ? absDropX : -absDropX;
            const dropY = seatDimensions.h;
            dispatch(addPlayerAnimation(seatIndex, { type: 'sit', dropX, dropY, durationMs: 1000 }));
        }
    };
}
export function thunkMaybeTriggerSitPlayerAnimation(seatIndex) {
    return function (dispatch, getState) {
        const seatedPlayer = getState().poker.seatedPlayers[seatIndex];
        if (seatedPlayer?.isSitAnimationPending) {
            dispatch(unsetPendingSitPlayerAnimation(seatIndex));
            dispatch(thunkAddSitPlayerAnimation(seatIndex));
        }
    };
}
export function thunkBounceSeatedPlayerFromInbound(inbound) {
    return function (dispatch, getState) {
        const { playerId } = inbound;
        const seatedPlayer = Object.values(getState().poker.seatedPlayers).find((currSeatedPlayer) => currSeatedPlayer?.id === playerId);
        if (seatedPlayer) {
            dispatch(thunkAddSitPlayerAnimation(seatedPlayer.seatIndex));
            if (seatedPlayer.isSitAnimationPending) {
                dispatch(unsetPendingSitPlayerAnimation(seatedPlayer.seatIndex));
            }
        }
    };
}
export function clearPlayerAnimations(seatIndex) {
    return {
        type: CLEAR_PLAYER_ANIMATIONS,
        payload: seatIndex
    };
}
export function addTableShakeAnimation(tableShakeProperties) {
    return {
        type: ADD_TABLE_SHAKE_ANIMATION,
        payload: tableShakeProperties
    };
}
export function removeTableShakeAnimation(tableShakeAnimationId) {
    return {
        type: REMOVE_TABLE_SHAKE_ANIMATION,
        payload: tableShakeAnimationId
    };
}
